import { CSSProperties, Dispatch, forwardRef, PropsWithChildren, SetStateAction } from 'react'
import PlusIcon from '@/assets/icons/plus.svg?react'
import DropdownFadeInPanel from '@/shared/Dropdowns/DropdownFadeInPanel'
import ClickableIcon from '@/shared/Common/ClickableIcon'

interface IProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  style?: CSSProperties
  iconStyle?: CSSProperties
  menuStyle?: CSSProperties
  onOpenStateChange?: (open: boolean) => void
  position?: 'right' | 'left'
}

const DropdownUnderPlusIcon = forwardRef<HTMLDivElement, PropsWithChildren<IProps>>((props, ref) => {
  return (
    <div ref={ref} style={{ position: 'relative' }} onClick={(ev) => ev.stopPropagation()} data-open={open}>
      <ClickableIcon
        icon={PlusIcon}
        active={props.open}
        onClick={() => props.setOpen((prev) => !prev)}
        size="default"
      />
      <DropdownFadeInPanel
        open={props.open}
        style={{ top: '28px', width: '220px' }}
        onClick={() => props.setOpen(false)}
        position={props.position || 'right'}
      >
        {props.children}
      </DropdownFadeInPanel>
    </div>
  )
})

export default DropdownUnderPlusIcon
